import { useContext, useEffect, useState } from "react";
import LandLordContext from "../../../context/landlord/LandLordContext";
import { haveValue } from "../../../helper/common";
import { Modal } from "react-bootstrap";
import useTranslator from "../../../hooks/useTranslator";
import TenantContext from "../../../context/tenant/TenantContext";
import { toast } from "react-toastify";
import AuthContext from "../../../context/auth/AuthContext";

const AssignTenantLLModal = (props) => {
  const { _t } = useTranslator();
  const { getAgencyAgents, alreadySharedSubLL } = useContext(LandLordContext);
  const { shareProfile, removeSharedProfile } = useContext(TenantContext);
  const { setLoading } = useContext(AuthContext);
  const {
    tenant_id = null,
    openModal = false,
    handleCloseModal = () => {},
  } = props;

  const [landlordListing, setLandlordListing] = useState([]);
  const [alreadySharedListingArr, setAlreadySharedListingArr] = useState([]);
  const [alreadySharedListing, setAlreadySharedListing] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = () => {
    setLoading(true);
    getAgencyAgents()
      .then((res) => {
        const agentList = res?.data?.data;
        if (haveValue(agentList)) {
          setLandlordListing(agentList);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err, "Error inside getAgencyAgents");
      });
    alreadySharedSubLL(tenant_id)
      .then((res) => {
        const agentList = res?.data?.data;
        if (haveValue(agentList)) {
          const temp_list = agentList.map((agent) => agent?.landlord_info?._id);
          //   setAlreadySharedListing(agentList);
          setAlreadySharedListing(agentList);
          setAlreadySharedListingArr(temp_list);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err, "alreadySharedSubLL err");
      });
  };

  const handleShareProfile = async (tenant_id, landlord_id) => {
    shareProfile(tenant_id, landlord_id, "null", "full", {
      shareType: "parent_landlord",
      sendEmail: false,
    })
      .then((res) => {
        fetchData();
        toast.success(
          _t(
            "profileSharedSuccessfull",
            "Success popup when parent ll share a tenant profile with sub ll"
          )
        );
      })
      .catch((err) => {
        toast.error(
          _t(
            "errorWhileSharingProfile",
            "Error popup to show error while sharing profile"
          )
        );
      });
  };
  const handleUnShareProfile = async (landlord_id) => {
    const sharedProfile = alreadySharedListing.filter(
      (profile) => profile?.landlord_info?._id == landlord_id
    );
    const sharedProfileId = sharedProfile[0]?._id;

    if (haveValue(sharedProfileId)) {
      removeSharedProfile(sharedProfileId)
        .then((res) => {
          fetchData();
          toast.success(_t("profileUnshared"));
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <>
      <Modal
        show={openModal}
        onHide={handleCloseModal}
        centered
        className="newmodalui asguarantor share-profile"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {_t(
              "selectLLWithWhomYouWantToShareTheProfile",
              "In Modal when Parent LL is going to share a tenant profile with a Sub LL"
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {haveValue(landlordListing) &&
            Array.isArray(landlordListing) &&
            landlordListing.length > 0 ? (
              <ul>
                {landlordListing.map((ll_detail) => (
                  <li className="share-it">
                    {ll_detail?.fname_companyName} {ll_detail.lname}
                    {alreadySharedListingArr.includes(ll_detail?._id) ? (
                      <button
                      className="share-btn"
                        onClick={(e) => handleUnShareProfile(ll_detail?._id)}
                      >
                        {_t("unShare", "Button to un-share profile with ll")}
                      </button>
                    ) : (
                      <button
                      className=""
                        onClick={(e) =>
                          handleShareProfile(tenant_id, ll_detail?._id)
                        }
                      >
                        {_t("share", "Button to share profile with ll")}
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              _t(
                "noSubLLFound",
                "Shown when there is no entry in listing of Sub LL"
              )
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btngreen">{_t("done")}</button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AssignTenantLLModal;
